import { otherCategories } from '@/mocks/categories';

export default function CategoryGridB() {
  const firstRow = otherCategories.slice(0, 6);
  const secondRow = otherCategories.slice(6);

  return (
    <section className="w-full bg-background-50 pb-16 md:pb-20 px-4 md:px-8">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            Altre
            <br />
            Categorie
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md leading-relaxed md:pt-3">
            Esplora tutte le altre categorie disponibili. Ogni link ti porterà direttamente ai prodotti selezionati su Itaobuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {firstRow.map((cat, index) => {
            const isDark = index === 0 || index === 3;
            return (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className={'group rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer ' + (isDark ? 'bg-secondary-800' : 'bg-background-100')}
                style={{ animation: 'fadeInUp 0.7s ease-out ' + (index * 0.08) + 's forwards', opacity: 0 }}
              >
                <div className="h-48 md:h-56 overflow-hidden">
                  <img
                    src={cat.imageUrl}
                    alt={'Itaobuy Spreadsheet ' + cat.nameIt}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <h3 className={'font-heading text-lg md:text-xl font-semibold mb-1 ' + (isDark ? 'text-background-50' : 'text-foreground-950')}>
                    {cat.nameIt}
                  </h3>
                  <p className={'text-sm flex items-center gap-1.5 ' + (isDark ? 'text-background-50/60' : 'text-foreground-500')}>
                    <span>{cat.name}</span>
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </p>
                </div>
              </a>
            );
          })}
        </div>

        {secondRow.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
            {secondRow.map((cat, index) => {
              const isDark = index === 0 || index === 3;
              return (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className={'group rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer ' + (isDark ? 'bg-secondary-800' : 'bg-background-100')}
                  style={{ animation: 'fadeInUp 0.7s ease-out ' + (index * 0.08) + 's forwards', opacity: 0 }}
                >
                  <div className="h-48 md:h-56 overflow-hidden">
                    <img
                      src={cat.imageUrl}
                      alt={'Itaobuy Spreadsheet ' + cat.nameIt}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5 md:p-6">
                    <h3 className={'font-heading text-lg md:text-xl font-semibold mb-1 ' + (isDark ? 'text-background-50' : 'text-foreground-950')}>
                      {cat.nameIt}
                    </h3>
                    <p className={'text-sm flex items-center gap-1.5 ' + (isDark ? 'text-background-50/60' : 'text-foreground-500')}>
                      <span>{cat.name}</span>
                      <i className="ri-arrow-right-up-line text-xs"></i>
                    </p>
                  </div>
                </a>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}